'use client';

import { useSearchParams } from 'next/navigation';

type FreePlayPageProps = {
  adactDomain: string;
};

function FreePlayPage({ adactDomain }: FreePlayPageProps) {
  const searchParams = useSearchParams();
  const campaign = searchParams.get('campaign');
  const customerIdToken = searchParams.get('customerIdToken');

  const iframeSrc = `${adactDomain}/${campaign ?? ''}?customerIdToken=${customerIdToken ?? ''}`;

  return (
    <div className="ll-container-full">
      <iframe
        data-testid="free-play-iframe"
        className="w-full h-[calc(100dvh-var(--sticky-primary-header-height,64px))] min-h-[480px]"
        src={iframeSrc}
        title="Free Play"
        sandbox="allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation"
      />
    </div>
  );
}

export { FreePlayPage };
